import { render, staticRenderFns } from "./energy-cost-chengben.vue?vue&type=template&id=8272c7cc&"
import script from "./energy-cost-chengben.vue?vue&type=script&lang=js&"
export * from "./energy-cost-chengben.vue?vue&type=script&lang=js&"
import style0 from "./energy-cost-chengben.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports